import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

export const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/api`,
});

// Called once from App.js with the Auth0 `getAccessTokenSilently` function so every
// request automatically carries a fresh bearer token.
export function attachAuthInterceptor(getAccessToken) {
  apiClient.interceptors.request.use(async (config) => {
    const token = await getAccessToken();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
}
